import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TranslatorService {

  private defaultLanguage = 'it';

  private availablelangs = [
    { code: 'en', text: 'English' },
    { code: 'it', text: 'Italian' }
  ];

  constructor(public translate: TranslateService, private http: HttpClient) {

    if (!translate.getDefaultLang()) {
      translate.setDefaultLang(this.defaultLanguage);
    }
    this.useLanguage();

  }

  getDefaultLanguage() {
    return this.translate.getDefaultLang();
  }

  useLanguage(lang: string = '') {
    this.translate.use(lang || this.translate.getDefaultLang());
  }

  getAvailableLanguages() {
    return this.availablelangs;
  }

  checkTranslationExistence(key: string): boolean {
    return this.translate.instant(key).split('.').length === 1;
  }
}
